import axios from "axios";
import { getPageSessionID } from "./clientSession";

declare global {
  interface Window {
    __API_BASE__?: string;
  }
}

const api = axios.create({
  baseURL: window.__API_BASE__ ?? "/",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers["X-UI-Session"] = getPageSessionID();
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const message =
        error.response.data?.error ||
        error.response.data?.message ||
        error.message;
      return Promise.reject(new Error(message));
    }
    if (error.request) {
      return Promise.reject(
        new Error("No response from backend. Check connectivity.")
      );
    }
    return Promise.reject(error);
  }
);

export default api;
